import states from '@/store/modules/interactable-windows/states'

export default {
  namespaced: true,
  modules: {
    states
  }
}
